export default function initFeaturedSlider() {
    const section = document.querySelector(".gh-featured-section");
    if (!section) return;

    const viewport = section.querySelector(".gh-featured-viewport");
    const track = section.querySelector(".gh-featured-track");
    const prevBtn = section.querySelector(".gh-featured-prev");
    const nextBtn = section.querySelector(".gh-featured-next");
    const cards = section.querySelectorAll(".gh-featured-card");

    if (!viewport || !track || cards.length === 0) return;

    // Helper to calculate scroll amount (scroll by 1 card or full visible width)
    function getScrollStep() {
        if (cards.length === 0) return 300;
        const cardWidth = cards[0].getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 24;
        return cardWidth + gap;
    }

    function updateNavButtons() {
        if (!prevBtn || !nextBtn) return;
        const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;

        // Disable prev button if at start
        if (viewport.scrollLeft <= 5) {
            prevBtn.disabled = true;
        } else {
            prevBtn.disabled = false;
        }

        // Disable next button if at end
        if (viewport.scrollLeft >= maxScrollLeft - 5) {
            nextBtn.disabled = true;
        } else {
            nextBtn.disabled = false;
        }
    }

    function scrollNext() {
        const step = getScrollStep();
        const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
        if (viewport.scrollLeft >= maxScrollLeft - 5) {
            // Loop back to start if at the end
            viewport.scrollTo({ left: 0, behavior: "smooth" });
        } else {
            viewport.scrollBy({ left: step, behavior: "smooth" });
        }
    }

    function scrollPrev() {
        const step = getScrollStep();
        const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
        if (viewport.scrollLeft <= 5) {
            // Loop to the end if at the start
            viewport.scrollTo({ left: maxScrollLeft, behavior: "smooth" });
        } else {
            viewport.scrollBy({ left: -step, behavior: "smooth" });
        }
    }

    if (nextBtn) {
        nextBtn.addEventListener("click", scrollNext);
    }

    if (prevBtn) {
        prevBtn.addEventListener("click", scrollPrev);
    }

    viewport.addEventListener("scroll", () => {
        // debounce or raf for button state
        window.requestAnimationFrame(updateNavButtons);
    }, { passive: true });

    window.addEventListener("resize", () => {
        updateNavButtons();
    }, { passive: true });

    // Initial check
    updateNavButtons();
}
